<template>
  <div>
    <!-- 标题 -->
    <!-- <h3>今年利润合计: {{ yeartitle }}元 本月利润合计: {{ monthtitle }}元</h3> -->
    <!-- TAB目录 -->
    <Row
      :gutter="8"
      style="margin: 0px 0 0 0; width: 100%"
      v-if="menus && menus.length > 0"
    >
      <Menu
        mode="horizontal"
        :active-name="menu_name"
        @on-select="selectMenu"
        style="width: 100%"
      >
        <div v-for="(v, k) in menus" style="display: inline-block" :key="k">
          <MenuItem
            :name="v.name"
            v-auth="v.auth"
            @click="v.onClick"
            v-show="v.show === true ? false : true"
          >
            <Badge
              :overflow-count="10000000"
              v-if="v.badge && v.badge.count"
              :count="v.badge.count"
              :offset="[18, -3]"
            >
              {{ v.label }}
            </Badge>
            <span v-if="!(v.badge && v.badge.count)">
              {{ v.label }}
            </span>
          </MenuItem>
        </div>
      </Menu>
    </Row>

    <Row
      :gutter="8"
      style="margin: 0px 0 0 0; width: 100%"
      v-if="filters && filters.length > 0"
    >
      <Collapse style="width: 100%" v-model="value1">
        <!--  -->
        <Panel style="width: 100%" name="2">
          展开搜索条件
          <Form
            ref="formQuery"
            :label-width="75"
            :label-position="left"
            :label-colon="true"
            :model="query"
            style="
              display: flex;
              flex-direction: row-reverse;
              justify-content: flex-end;
              flex-wrap: wrap;
              width: 80%;
              margin-top: 10px;
            "
            slot="content"
          >
            <Col
              span="3"
              :xxl="6"
              :xl="4"
              :lg="6"
              :md="8"
              :sm="12"
              :xs="24"
              style="
                display: flex;
                flex-direction: row-reverse;
                position: absolute;
                right: 20px;
              "
            >
              <Button icon="ios-search" type="info" @click="search" style="width: 90px"
                >搜索
              </Button>
              <Button
                icon="ios-close-circle"
                type="error"
                @click="clearFilter"
                v-show="query.isClearFilterReset == true ? false : true"
                style="width: 90px; margin-right: 15px"
                >重置
              </Button>
            </Col>
            <template v-for="(v, k) in filters">
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-if="v.type === 'inputs'"
                style="margin: 0px 0 10px 0; float: right; display: flex"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <div style="margin-bottom: 0; display: flex">
                    <Input
                      :key="k"
                      :placeholder="'最小' + v.label"
                      clearable
                      v-model="query[v.name1]"
                    ></Input>
                    <div>~</div>
                    <Input
                      :key="k"
                      :placeholder="'最大' + v.label"
                      clearable
                      v-model="query[v.name2]"
                    ></Input>
                  </div>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-if="v.type === 'string' || v.type === 'text' || v.type === 'input'"
                style="margin: 0px 0 10px 0; float: right; display: flex"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <Input
                    :key="k"
                    :placeholder="v.label"
                    clearable
                    v-model="query[v.name]"
                    @keyup.enter.native="v.KeyEnter"
                  ></Input>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'select'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <i-select
                    :key="k"
                    v-model="query[v.name]"
                    clearable
                    style="width: 190px"
                    @keyup.enter.native="v.KeyEnter"
                    :multiple="v.multiple ? true : false"
                    :disabled="v.disabled ? true : false"
                    :placeholder="v.label"
                    :filterable="true"
                    @on-change="v.onChange"
                  >
                    <Option :value="s.value" v-for="(s, sk) in v.dropList || []" :key="sk"
                      >{{ s.name }}
                    </Option>
                  </i-select>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'selectsearch'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <i-select
                    :key="k"
                    v-model="query[v.name]"
                    clearable
                    remote
                    filterable
                    @keyup.enter.native="v.KeyEnter"
                    :remote-method="v.remoteMethod"
                    style="width: 190px"
                    :multiple="v.multiple ? true : false"
                    :disabled="v.disabled ? true : false"
                    :placeholder="v.label"
                    @on-change="v.onChange"
                  >
                    <Option :value="s.value" v-for="(s, sk) in v.dropList || []" :key="sk"
                      >{{ s.name }}
                    </Option>
                  </i-select>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'datetimeyear'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <DatePicker
                    clearable
                    :key="k"
                    type="year"
                    v-model="query1[v.name + v.lable]"
                    style="width: 190px"
                    @keyup.enter.native="v.KeyEnter"
                    format="yyyy"
                    placeholder="选择时间"
                    :options="options"
                    @on-change="
                      (val) => {
                        timeDateChangeYear(val, v.name);
                      }
                    "
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'contractdatetimerange'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <DatePicker
                    clearable
                    :key="k"
                    type="daterange"
                    v-model="query1[v.name + v.lable]"
                    style="width: 190px"
                    @keyup.enter.native="v.KeyEnter"
                    format="yyyy-MM-dd"
                    placeholder="选择时间"
                    @on-change="
                      (val) => {
                        timeDateChange(val, v.name);
                      }
                    "
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'datetimerangemonth'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <DatePicker
                    clearable
                    :key="k"
                    type="month"
                    :options="options"
                    v-model="query[v.name]"
                    style="width: 190px"
                    @keyup.enter.native="v.KeyEnter"
                    format="yyyy-MM"
                    placeholder="选择时间"
                    @on-change="
                      (val) => {
                        timeDateChangeMonth(val, v.name);
                      }
                    "
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col
                :key="k"
                v-else-if="v.type === 'distpicker'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormAddress
                  @on-change="
                    (val) => {
                      onAddressChange(val, v.name);
                    }
                  "
                  style="width: 100%"
                ></FormAddress>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'addressInfo'"
                style="width: auto; margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <v-distpicker
                    :disabeld="disabeld"
                    type="addressInfo"
                    :province="province"
                    :city="city"
                    :area="area"
                    @selected="v.onSelect"
                  ></v-distpicker>
                </FormItem>
              </Col>
            </template>
          </Form>
        </Panel>
      </Collapse>
    </Row>

    <Row justify="end" class="code-row-bg">
      <Col
        :span="k == 2 ? '4' : '3'"
        v-for="(v, k) in titleList"
        :key="k"
        :style="{ color: v.color }"
        >{{ v.name }}: ¥{{ v.totalMoney.toFixed(2) }}</Col
      >
    </Row>

    <!-- 操作 -->
    <Row
      :gutter="8"
      style="margin: 10px 0 0 0; width: 100%"
      v-if="actions && actions.length > 0"
    >
      <div
        v-for="(v, k) in actions"
        :key="k"
        style="margin-right: 10px; display: inline-flex"
      >
        <Button
          :size="v.size || 'default'"
          :type="v.type || 'warning'"
          v-auth="v.auth"
          :icon="v.icon || ''"
          @click="v.onClick"
          >{{ v.label }}
        </Button>
      </div>
    </Row>

    <!-- 表格 -->
    <Row :gutter="8" style="width: 100%">
      <edit-table
        ref="tablelist"
        :query="query"
        :table="table"
        :order="table.order || ''"
        :rowClassName="table.rowClassName"
        :output="table.output"
        :border="table.border"
        :stripe="table.stripe"
        :header="table.header"
        :footer="table.footer"
        :columns-list="tableCols"
        :handleSpan="handleSpan"
        @on-select="handleSelect"
        @getdata="getdata"
        @on-edit="handleEdit"
        @on-info="handleInfo"
        @on-del="handleDel"
      >
        <div slot="action" v-if="tactions && tactions.length > 0">
          <div
            v-for="(v, k) in tactions"
            :key="k"
            style="margin-right: 10px; display: inline-flex"
          >
            <Button
              :size="v.size || 'default'"
              :type="v.type || 'primary'"
              v-auth="v.auth"
              :icon="v.icon || ''"
              :disabled="v.disabled"
              @click="v.onClick"
              >{{ v.label }}
            </Button>
          </div>
        </div>
      </edit-table>
      <!-- <Badge   v-if="hospitaltype=='购物车'" :count="num" style="margin-top: 50px" > <Button @click="handleSubmit" style="background: #00c261;color: #f8f8f9;">提交申请</Button></Badge> -->
    </Row>
    <!-- 侧栏详情 -->
    <Drawer title="详情" :closable="true" width="640" v-model="drawerBox">
      <component :is="drawerName" :kv="drawerKv"></component>
    </Drawer>
    <!-- 动态组件 -->
    <component
      v-for="(item, index) in extRender || []"
      :key="index"
      :ref="item"
      :is="item"
    ></component>
  </div>
</template>
<script>
import baseList from "@/views/components/base/baseList.vue";
export default {
  extends: baseList,
  components: {
    baseList,
  },
  data() {
    return {
      options: {
        disabledDate(date) {
          return date && date.valueOf() >= Date.now();
        },
      },
      authid: "",
      menus: [
        {
          label: "本月利润",
          name: "costing_list",
          auth: "",
        },
        {
          label: "当月收入",
          name: "MonthlyIncome_list",
          auth: "",
        },
        {
          label: "物资成本",
          name: "Consumablescost_list",
          auth: "",
        },
        {
          label: "服务成本",
          name: "Cost_list",
          auth: "",
        },
        {
          label: "销售佣金",
          name: "Commissions_list",
          auth: "",
        },
      ],
      table: {
        mname: "",
        key: "id",
        url: {
          list: "/admin/system/revenue/list",
          del: "/admin/system/revenue/del",
        },
        output: false,
      },
      actions: [],
      filters: [
        {
          label: "医院名称",
          KeyEnter: this.search,
          name: "customerId",
          value: "",
          type: "select",
          dropList: [],
        },
        {
          label: "月份",
          KeyEnter: this.search,
          name: "monthNum",
          value: "",
          type: "select",
          dropList: [
            {
              name: "1月",
              value: "1",
            },
            {
              name: "2月",
              value: "2",
            },
            {
              name: "3月",
              value: "3",
            },
            {
              name: "4月",
              value: "4",
            },
            {
              name: "5月",
              value: "5",
            },
            {
              name: "6月",
              value: "6",
            },
            {
              name: "7月",
              value: "7",
            },
            {
              name: "8月",
              value: "8",
            },
            {
              name: "9月",
              value: "9",
            },
            {
              name: "10月",
              value: "10",
            },
            {
              name: "11月",
              value: "11",
            },
            {
              name: "12月",
              value: "12",
            },
          ],
        },
        {
          label: "年份",
          KeyEnter: this.search,
          name: "yearNum",
          value: "",
          type: "datetimeyear",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "日期",
          minWidth: 90,
          align: "center",
          key: "monthTime",
        },
        {
          title: "医院名称",
          minWidth: 240,
          align: "left",
          key: "customerName",
        },

        {
          title: "当月收入",
          minWidth: 160,
          align: "center",
          key: "monthRevenue",
          render: (h, params) => {
            const row = params.row;
            const budget = row.monthRevenue;
            const num = new Intl.NumberFormat("zh-CN", {
              style: "currency",
              currency: "CNY",
            }).format(budget);
            return (
              <div>
                <p style={{ "font-size": "14px" }}>{num}</p>
              </div>
            );
          },
        },
        {
          title: "物资成本",
          minWidth: 160,
          align: "center",
          key: "consumableMonthMoney",
          render: (h, params) => {
            const row = params.row;
            const budget = row.consumableMonthMoney;
            const num = new Intl.NumberFormat("zh-CN", {
              style: "currency",
              currency: "CNY",
            }).format(budget);
            return (
              <div>
                <p
                  style="color:#3591f1; cursor: pointer;"
                  onClick={() => this.goInfo(row)}
                >
                  {num}
                </p>
              </div>
            );
          },
        },
        {
          title: "服务成本",
          minWidth: 180,
          align: "center",
          key: "payRollMoney",
          render: (h, params) => {
            const row = params.row;
            const budget = row.payRollMoney;
            const num = new Intl.NumberFormat("zh-CN", {
              style: "currency",
              currency: "CNY",
            }).format(budget);
            return (
              <div>
                <p style={{ "font-size": "14px" }}>{num}</p>
              </div>
            );
          },
        },
        {
          title: "销售佣金",
          minWidth: 180,
          align: "center",
          key: "shellRollMoney",
          render: (h, params) => {
            const row = params.row;
            const budget = row.shellRollMoney;
            const num = new Intl.NumberFormat("zh-CN", {
              style: "currency",
              currency: "CNY",
            }).format(budget);
            return (
              <div>
                <p style={{ "font-size": "14px" }}>{num}</p>
              </div>
            );
          },
        },
        {
          title: "毛利润",
          minWidth: 180,
          align: "center",
          key: "netProfit",
          render: (h, params) => {
            const row = params.row;
            const budget = row.netProfit;
            const num = new Intl.NumberFormat("zh-CN", {
              style: "currency",
              currency: "CNY",
            }).format(budget);
            return (
              <div>
                <p style={{ "font-size": "14px" }}>{num}</p>
              </div>
            );
          },
        },
      ],
      yeartitle: "",
      monthtitle: "",
      titleList: [],
      zong: 0,
      wuzi: 0,
      fuwu: 0,
      yongjin: 0,
      lirun: 0,
    };
  },
  created() {
    this.query1 = {};
    this.query = {};
    this.getyearList();
    this.deskChange();
  },
  methods: {
    async getdata(data) {
      if (data) {
        let d = this.query;
        if (d.yearNum === "") {
          d.yearNum == null;
        }
        if (d.monthNum === "") {
          d.monthNum == null;
        }
        let res = await $utils.api.load("/admin/system/revenue/titleList", d, "get");
        if (res.code == 200) {
          this.titleList = res.data;
        }
        /* let zong1 = 0;
        let wu1 = 0;
        let fu1 = 0;
        let yong1 = 0;
        let li1 = 0;
        data.forEach((item, index) => {
          if (item.monthRevenue) {
            zong1 += item.monthRevenue;
          }
          if (item.consumableMonthMoney) {
            wu1 += item.consumableMonthMoney;
          }
          if (item.payRollMoney) {
            fu1 += item.payRollMoney;
          }
          if (item.shellRollMoney) {
            yong1 += item.shellRollMoney;
          }
          if (item.netProfit) {
            li1 += item.netProfit;
          }
        });
        this.zong = zong1.toFixed(2);
        this.wuzi = wu1.toFixed(2);
        this.fuwu = fu1.toFixed(2);
        this.yongjin = yong1.toFixed(2);
        this.lirun = li1.toFixed(2); */
      }
    },
    goInfo(row) {
      $utils.url.push({
        name: "purchaseIndexAdmin",
        query: {
          customerName: row.customerName,
          receiveTime: this.getMonthStartAndEnd(row.monthTime, 1),
          begin: this.getMonthStartAndEnd(row.monthTime, 2).begin,
          end: this.getMonthStartAndEnd(row.monthTime, 2).end,
        },
      });
    },
    getMonthStartAndEnd(dateString, num) {
      const parts = dateString.split("-");
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const monthStart = new Date(Date.UTC(year, month, 1));
      const monthEnd = new Date(Date.UTC(year, month + 1, 0));
      const formattedStart = monthStart.toISOString().split("T")[0];
      const formattedEnd = monthEnd.toISOString().split("T")[0];
      if (num == 1) {
        return `${formattedStart} - ${formattedEnd}`;
      }
      if (num == 2) {
        return {
          begin: formattedStart,
          end: formattedEnd,
        };
      }
    },
    timeDateChangeYear(val, name) {
      this.query.yearNum = val;
    },
    async getyearList() {
      let d = {};
      let res = await $utils.api.load("/admin/system/revenue/yearList", d, "get");
      if (res.code == 200) {
        let num1 = res.data[1].totalMoney;
        let num2 = res.data[0].totalMoney;
        this.yeartitle = Number(num1.toFixed(2));
        this.monthtitle = Number(num2.toFixed(2));
      }
    },
    deskChange() {
      let q = {};
      $utils.api.load("/admin/system/customer/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.customerName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "customerId") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.code-row-bg {
  margin: 10px 0;
  font-size: 14px;
  font-weight: 700;
  color: #515a6e;
}
</style>
